import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { URLS } from "../../../infra/URLS";
import getAuditoria, { getAuditoriaForId } from "../queries/getAuditoria";

export function useGetAuditoria(
  data?: any, 
  page: number = 1
) {
  const {Usuario, Tabela, DataCriacao} = data;
  const periodoInicial = !DataCriacao ? '' : moment(DataCriacao[0]).format('YYYY-MM-DD');
  const periodoFinal = !DataCriacao ? '' : moment(DataCriacao[1]).format('YYYY-MM-DD');
  
  const resultQuery = useQuery(
    [`${URLS.AUDITORIA_API}`, {
      params: {
        usuario: Usuario,
        tabela: Tabela,
        periodoInicial,
        periodoFinal,
        page,
      }
    }],
  () => getAuditoria(Usuario, Tabela, periodoInicial, periodoFinal, page)
);

return resultQuery;
}

export function useGetAuditoriaForId(auditoriaId: number) {
  const resultQuery = useQuery([`${URLS.AUDITORIA_ID_API.replace('id', auditoriaId.toString())}`], 
  () => getAuditoriaForId(auditoriaId));

  return resultQuery;
}
